import { render } from "./Carousel.vue?vue&type=template&id=a8be059e&scoped=true"
const script = {}

import "./Carousel.vue?vue&type=style&index=0&id=a8be059e&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-a8be059e"]])

export default __exports__